module.exports = __webpack_public_path__ + "static/media/moi-logo.e47e4099.svg";